export default "__VITE_ASSET__6185b107__"